import { CardGroup as PatternCardGroup } from "@modernatx-internal/website-pattern-library";
import React from "react";

import { CardGroupContent, CardGroupItemContent, ContentComponentProps } from "@/content-V2/types";

type PatternCardGroupProps = React.ComponentProps<typeof PatternCardGroup>;
type PatternCardGroupItem = PatternCardGroupProps["items"][number];
type CardGroupItemProps = ContentComponentProps<CardGroupItemContent>;

const isCardGroupItemElement = (
  child: React.ReactNode
): child is React.ReactElement<CardGroupItemProps> =>
  React.isValidElement<CardGroupItemProps>(child) && child.type === CardGroupItem;

export const CardGroupItem: React.FC<CardGroupItemProps> = () => null;

CardGroupItem.displayName = "CardGroupItem";

export const CardGroup: React.FC<ContentComponentProps<CardGroupContent>> = ({
  children,
  ...props
}) => {
  const items = React.Children.toArray(children).flatMap((child, index) => {
    if (!isCardGroupItemElement(child)) {
      return [];
    }

    const itemProps = Object.fromEntries(
      Object.entries(child.props).filter(([key]) => key !== "children")
    ) as Omit<CardGroupItemProps, "children">;
    const fallbackId =
      typeof child.key === "string" || typeof child.key === "number"
        ? String(child.key).replace(/^\.\$?/, "")
        : `card-group-item-${index}`;

    const resolvedItem: PatternCardGroupItem = {
      ...itemProps,
      id: itemProps.id ?? fallbackId
    };

    return [resolvedItem];
  });

  if (!items.length) {
    return null;
  }

  return <PatternCardGroup {...(props as PatternCardGroupProps)} items={items} />;
};
